export interface IOrderLine {
    id?: string;
    handlingUnit?: string;
    sourcePlant: string;
    sourceCountry: string;
    smn: string;
    materialDescription: string;
    salesOrderQuantity: number;
    affectedQuantity: number;
    price: number;
    shipToCountryCode: string;
    salesOrderLine: number;
    deliveryNumber?: string;
    batch?: string;
    soCreationDate: string;
    transportUnit?: string;
    salesOrderNumber?: string;
    purchaseOrderReference?: string;
    invoiceNumber?: string;
    salesOrganisation?: string;
    route?: string;
    shipToCustomerNumber?: string;
    shipToCustomerName?: string;
    soldToCustomerName?: string;
}
